import { render, staticRenderFns } from "./ReportTemplates.vue?vue&type=template&id=49a968f9&scoped=true"
import script from "./ReportTemplates.vue?vue&type=script&lang=js"
export * from "./ReportTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a968f9",
  null
  
)

export default component.exports